import { useQuery } from "@tanstack/react-query";
import { Moment, API } from "config";

const usePurchaseSaleDetails = ({
                                    page = 1,
                                    period,
                                    order_by = "total_sales",
                                    type = 2,
                                }) => {
    return useQuery({
        queryKey: ["purchaseSaleDetails", page, period, order_by, type],
        queryFn: async () => {
            // Validação básica do período
            if (!period || !Array.isArray(period) || period.length !== 2) {
                throw new Error("Período inválido");
            }

            const [startDate, endDate] = period;

            if (
                !startDate ||
                !endDate ||
                isNaN(new Date(startDate).getTime()) ||
                isNaN(new Date(endDate).getTime())
            ) {
                throw new Error("Datas inválidas no período");
            }

            const startFormatted = Moment(startDate).format("YYYY-MM-DD");
            const endFormatted = Moment(endDate).format("YYYY-MM-DD");

            // Monta a URL com os parâmetros necessários
            const url =
                `/reports/purchase-sale-details?page=${page}` +
                `&period[]=${startFormatted}` +
                `&period[]=${endFormatted}` +
                (order_by ? `&order_by=${order_by}` : "") +
                (type ? `&type=${type}` : "");

            const response = await API.get(url);
            return response?.data;
        },
        keepPreviousData: true,
    });
};

export default usePurchaseSaleDetails;
